module.exports = __webpack_public_path__ + "img/flow-icons.4a3417bc.svg";